import { Link } from 'react-router-dom';
import { styled, Theme } from '@mui/material';

export const sxStyles = {
  programTitle: (theme: Theme) => ({
    marginTop: '0.25rem',
    color: theme.palette.primary.main,
  }),
  favorite: {
    height: '50px',
    width: '50%',
    transition: 'background-color 0.5s',
  },
};

export const StyledAreaProgramCardsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  maxWidth: '272px',
  width: '100%',
  minHeight: '188px',
  background: theme.palette.common.white,
  boxShadow: `0px 3px 14px 2px ${theme.palette.divider}`,
  borderTop: `5px solid ${theme.palette.primary.main}`,
  borderRadius: '0px 0px 4px 4px',
  padding: '1.25rem',
  paddingBottom: 0,
}));

export const StyledActionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  maxWidth: '232px',
  width: '100%',
  minHeight: '70px',
  borderTop: `1px solid ${theme.palette.grey['300']}`,

  '&:before': {
    content: '""',
    position: 'absolute',
    height: '50px',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '1px',
    backgroundColor: theme.palette.grey['300'],
  },
}));

export const StyledMoreLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '50px',
  width: '50%',
  fontWeight: 600,
  color: theme.palette.primary.main,
  transition: 'background-color 0.5s',

  '& > svg:first-of-type': {
    marginLeft: '1rem',
    fill: theme.palette.primary.main,
  },

  ':hover': {
    // TODO add color to library
    backgroundColor: '#EBF6F7',
  },
}));

export const StyledFitChip = styled('div', {
  shouldForwardProp: (prop) => prop !== '$backgroundColor',
})<{ $backgroundColor: string }>(({ theme, $backgroundColor }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  alignSelf: 'flex-start',
  padding: '0.125rem 0.5rem',
  borderRadius: '1rem',
  backgroundColor: $backgroundColor,
  border: `1px solid ${theme.palette.common.black}`,
}));
